export default __webpack_public_path__ + "assets/_Chapters/LEANdustry/lean-management.webp";